import * as React from 'react';
import { NavLink as ReactRouterNavLink, NavLinkProps as RouterLinkProps } from 'react-router-dom';
import { withTheme, WithTheme } from '@material-ui/core/styles';

type FixedNavLinkProps = Omit<RouterLinkProps, 'innerRef'>;

type Props = WithTheme & FixedNavLinkProps;

const NavLinkComponent = React.forwardRef<HTMLAnchorElement, Props>(({ theme, ...props }, ref) => (
  <ReactRouterNavLink
    innerRef={ref}
    activeStyle={{
      backgroundColor: theme.palette.action.selected
    }}
    {...props}
  />
));

export const NavLink = withTheme(NavLinkComponent);
